<template>
    <div id="projects-sidebar-menu" class="sidebar-menu-container">
        <div id="new-project-frame">
            <div class="red-pill-button-of-hate" v-on:click="createNewProject">Новый проект</div>
        </div>
        <label id="project-search-label">
            <input type="text" id="project-search" placeholder="Найти проект" v-model="mask">
        </label>
        <div v-if="projectSelected">
            <div class="sidebar-sub-label">Название проекта:</div>
            <div class="sidebar-text">
                <span class="project-name">
                    {{nameActiveProject}}
                </span>
            </div>

            <!--            !!!!!!!!!!!Для редактирования названия проекта!-->
            <!--            <div class="sidebar-text edit-text-grid">-->
            <!--                <span class="project-edit-button" v-on:click="showInputRename">-->
            <!--                    <SVGAdminEditRow/>-->
            <!--                </span>-->
            <!--                <span v-show="!showRenameInput" class="project-name">-->
            <!--                    {{nameActiveProject}}-->
            <!--                </span>-->
            <!--                <input v-show="showRenameInput" type="text" class="project-sidebar-text-input" :placeholder="nameActiveProject" v-model="inputName" v-on:change="renameProject">-->
            <!--            </div>-->
            <div class="project-stats">
                <div class="sidebar-stat-name stripe">Количество фотографий:</div>
                <div class="sidebar-stat-val stripe">{{numberPhotos}}</div>

                <div class="sidebar-stat-name">Количество дизайнов:</div>
                <div class="sidebar-stat-val">{{numberDesigns}}</div>

                <div class="sidebar-stat-name stripe">Количество стен:</div>
                <div class="sidebar-stat-val stripe">{{getNumberPlanesByType('wall')}}</div>

                <div class="sidebar-stat-name">Количество окон:</div>
                <div class="sidebar-stat-val">{{getNumberPlanesByType('window')}}</div>

                <div class="sidebar-stat-name stripe">Количество дверей:</div>
                <div class="sidebar-stat-val stripe">{{getNumberPlanesByType('door')}}</div>
            </div>
        </div>
<!--        {{dataActiveProject}}-->
    </div>
</template>

<script>
    import {modalMethods} from "../../common";
    import SVGEditProjectName from "../../SVG/SVGEditProjectName";
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";

    export default {
        name: "ProjectsSidebarMenu",
        components: {SVGAdminEditRow, SVGEditProjectName},
        mixins: [modalMethods],
        computed: {
            projectSelected() {
                let selectedProject = this.$store.state.route.params.projectUUID;
                if (typeof selectedProject !== 'undefined') {
                    return selectedProject
                } else {
                    return null
                }
            },
            nameActiveProject(){
                return this.$store.getters["active/NAME"];
            },
            numberPhotos(){
                const photoList = this.$store.getters["active/GET_ALL_PHOTO"];
                if(photoList){
                    return Object.keys(photoList).length
                }
                return 0;
            },
            numberDesigns(){
                const designList = this.$store.getters["active/ALL_DESIGNS"];
                if(designList){
                    return Object.keys(designList).length
                }
                return 0;
            },
            numberPlanes(){
                return this.$store.getters['active/NUMBER_PLANES_BY_TYPE'];
            },
            mask: {
                get() {
                    return this.$store.state.UI.loadedProjectList.mask;
                },
                set(value) {
                    this.$store.commit('UI/loadedProjectList/MASK', value);
                    if (this.timerId) {
                        clearTimeout(this.timerId);
                        this.timerId = null;
                    }
                    this.timerId = setTimeout(() => {
                        this.$store.commit("UI/loadedProjectList/CLEAR_UPLOADED_PROJECTS");
                        this.$store.dispatch('UI/loadedProjectList/GET_PROJECTS');
                        this.timerId = null;
                    }, 500);
                }
            },
        },
        methods: {
            getNumberPlanesByType(type){
                if(this.numberPlanes[type]){
                    return this.numberPlanes[type];
                } else {
                    return 0;
                }
            },
            createNewProject: async function () {
                const projectGUID = await this.$store.dispatch('projectList/CREATE_NEW_PROJECT');
                if (! await this.$store.dispatch('projectList/NEW_USER_EXECUTOR_ID', this.$store.state.profile.userId)) {
                    alert('Возникла ошибка, связанная с авторизацией. Попробуйте выйти из профиля и снова авторизироваться.');
                    return;
                }
                await this.$router.push({
                    name: "loadPhoto",
                    params: {projectUUID: projectGUID}
                }).catch(() => {});
            },
            // showInputRename() {
            //     this.inputName = ''
            //     this.showRenameInput = !this.showRenameInput
            // },
            // renameProject() {
            //     this.$store.dispatch('active/NAME', this.inputName)
            //     this.showInputRename()
            // }
        },
        data () {
            return {
                // showRenameInput: false,
                // inputName: '',
                timerId: null
            }
        }
    }
</script>

<style scoped>
    #new-project-frame {
        border: 2px dashed #ACACAC;
        height: 158px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #project-search-label {
        position: relative;
    }

    #project-search-label:before {
        content: "";
        position: absolute;
        left: 10px;
        top: 0;
        bottom: 0;
        width: 20px;
        background: url("data:image/svg+xml,%3Csvg%20width%3D%2720%27%20height%3D%2720%27%20viewBox%3D%270%200%2016%2016%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20d%3D%27M5.99967%201.3335C3.43024%201.3335%201.33301%203.43073%201.33301%206.00016C1.33301%208.5696%203.43024%2010.6668%205.99967%2010.6668C7.16501%2010.6668%208.22968%2010.2322%209.04915%209.521L9.33301%209.80485V10.6668L13.057%2014.3908C13.425%2014.7588%2014.0223%2014.7588%2014.3903%2014.3908C14.7583%2014.0228%2014.7583%2013.4255%2014.3903%2013.0575L10.6663%209.3335H9.80436L9.52051%209.04964C10.2317%208.23017%2010.6663%207.16549%2010.6663%206.00016C10.6663%203.43073%208.56911%201.3335%205.99967%201.3335ZM5.99967%202.66683C7.84852%202.66683%209.33301%204.15132%209.33301%206.00016C9.33301%207.84901%207.84852%209.3335%205.99967%209.3335C4.15083%209.3335%202.66634%207.84901%202.66634%206.00016C2.66634%204.15132%204.15083%202.66683%205.99967%202.66683Z%27%20fill%3D%27%23939393%27%2F%3E%3C%2Fsvg%3E") center / contain no-repeat;
    }

    #project-search {
        padding: 10px 10px 10px 40px;
        border: 1px solid #BDBDBD;
        margin: 20px 0;
        width: -moz-available;
        width: available;
        width: -webkit-fill-available;

    }

    #project-search:hover {
        border-color: #828282;
    }

    #project-search:focus {
        border-color: #828282;
    }

    .project-edit-button {
        cursor: pointer;
        color: #828282;
        vertical-align: middle;
    }

    .project-edit-button:hover{
        color: #727272;
    }

    .project-edit-button:active{
        color: #828282;
    }

    .project-sidebar-text-input {
        border: 1px solid #BDBDBD;
        padding: 2px 5px 3px 5px;
        width: available;
        width: -moz-available;
        width: -webkit-fill-available;
    }

    .project-sidebar-text-input:hover {
        border-color: #828282;
    }

    .project-sidebar-text-input:focus {
        border-color: #828282;
    }

    .edit-text-grid {
        display: grid;
        grid-template-columns: 30px auto;
        grid-column-gap: 5px;
    }

    @media screen and (max-height: 800px) {
        .project-stats {
            grid-template-columns: max-content auto;
            font-size: 12px;
        }
    }

    @media screen and (min-height: 800px) {
        .project-stats {
            grid-template-columns: max-content auto;
            font-size: 14px;
        }
    }

    .project-stats {
        display: grid;
        grid-template-columns: max-content auto;
    }

    .sidebar-stat-name {
        padding: 10px;
    }

    .sidebar-stat-val {
        padding: 10px;
        text-align: center;
    }

    .project-name {
        padding: 2px 0;
    }
</style>
